import { api } from "../axiosConfig";
import { notifyService } from "./notifyService";

export async function reportProblem(m) {
  return await api
    .post("/reportProblem", { text: m})
    .then((res) => notifyService(res.data))
    .catch((err) => console.log(err));
}
